import React, { useCallback, useContext } from "react"
import { AppContext } from '../../context'
import { Modal } from "./modal";

const HtmlOverlay = () => {
    const { htmlOverlay, setHtmlOverlay } = useContext(AppContext);

    const onClose = useCallback(() => {
        setHtmlOverlay(null);
    },[setHtmlOverlay])

    return (
        <Modal isOpen onClose={onClose} html={htmlOverlay} />
    )
}

export default () => {
    const { htmlOverlay } = useContext(AppContext);
    return htmlOverlay ? <HtmlOverlay/> : null
}
